import React from 'react';
import BaseIcon from './BaseIcon';

import { ReactComponent as IconPath } from 'assets/images/icons/extendedProfile/quality-process-icon.svg';

function QualityProcessIcon(props) {
  return <BaseIcon SVGElement={IconPath} {...props} />;
}

export default QualityProcessIcon;
